import { ABeagleContext } from '@buzzfeed/react-components';

export default ABeagleContext;
